export const RESEND_CODE = 'SIGNUP/RESEND_CODE'
export const RESUME_EMAIL_VERIFICATION = 'SIGNUP/RESUME_EMAIL_VERIFICATION'
